import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Category from "./pages/Category";
import TextDetail from "./pages/TextDetail";
import Search from "./pages/Search";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Author from "./pages/Author";
import Audios from "./pages/Audios";
import Favorites from "./pages/Favorites";
import ProtectedRoute from "./components/ProtectedRoute";
import PoemarioRedirect from "./components/PoemarioRedirect";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/prosa" element={<Category main="prosa" />} />
              <Route path="/prosa/:sub" element={<Category main="prosa" />} />
              <Route path="/versos" element={<Category main="versos" />} />
              <Route path="/versos/:sub" element={<Category main="versos" />} />
              <Route path="/texto/:id" element={<TextDetail />} />
              <Route path="/audios" element={<Audios />} />
              <Route path="/favoritos" element={<Favorites />} />
              <Route path="/buscar" element={<Search />} />
              <Route path="/autor" element={<Author />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/poemario" element={<PoemarioRedirect />} />
            <Route path="/poemario/" element={<PoemarioRedirect />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
